import styled from "styled-components";
import fontSize from "../../../global/fontSize";
import backgroundImgFHD from "../../../images/Home/LandingPage/background.webp";

export const LandingContainer = styled.div`
  position: relative;
  width: 100vw;
  height: 100vh;
  background: linear-gradient(rgba(0, 0, 0, 0), rgba(0, 0, 0, 0.25)), url(${backgroundImgFHD}) no-repeat;
  background-attachment: scroll;
  background-position: center;
  background-size: cover;
  color: white;
  overflow-x: hidden;
`;

export const HeaderBackground = styled.div`
  position: relative;
  width: 80%;
  height: 100%;
  clip-path: polygon(0 0, 100% 0, 45% 100%, 0% 100%);
  background: linear-gradient(rgba(0, 0, 0, 0.6), rgba(0, 0, 0, 0.1));
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;

  @media (max-width: 1044px) {
    width: 100%;
    clip-path: polygon(0 0, 100% 0, 100% 100%, 0% 100%);
  }

  @media (max-height: 750px) {
    width: 100%;
    clip-path: polygon(0 0, 100% 0, 100% 100%, 0% 100%);
    z-index: 1;
  }
`;

export const HeaderTextContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 65%;
  text-align: center;

  @media (max-width: 1044px) {
    width: 100%;
    margin-bottom: 350px;
  }

  @media (max-width: 450px) {
    width: 100%;
    margin-bottom: 150px;
  }

  @media (max-height: 800px) {
    margin-bottom: 0;
  }
`;

export const LandingHeader = styled.h1`
  font-family: "League Gothic", sans-serif;
  font-size: ${fontSize.mainHeader};
  font-weight: 500;
  letter-spacing: 1px;
  margin-bottom: 40px;
  position: relative;

  @media (max-width: 1250px) {
    font-size: 4rem;
    margin-bottom: 30px;
  }

  @media (max-width: 720px) {
    font-size: ${fontSize.smallHeader};
  }

  @media (max-width: 499px) {
    font-size: ${fontSize.mostSmallHeader};
  }
`;

export const ForkliftImg = styled.img`
  position: absolute;
  width: 920px;
  bottom: 0;
  right: -70px;

  @media (max-width: 1500px) {
    width: 830px;
    bottom: 3%;
  }

  @media (max-width: 1400px) {
    width: 750px;
    bottom: 5%;
  }

  @media (min-height: 1300px) {
    bottom: 50%;
    transform: translateY(50%);
    width: 750px;
  }

  @media (max-width: 1250px) {
    width: 600px;
    bottom: 10%;
    right: -50px;
  }

  @media (max-width: 1044px) {
    height: 60%;
    right: unset;
    left: 50%;
    transform: translateX(-50%);
    width: auto;
    bottom: 0%;
  }

  @media (max-width: 500px) {
    height: auto;
    width: 100%;
  }

  @media (max-height: 800px) and (max-width: 500px) {
    display: none;
  }

  @media (max-height: 800px) {
    width: 700px;
  }
`;

export const ButtonsContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 1rem;
`;

export const ArrowDown = styled.img`
  position: absolute;
  bottom: 5px;
  left: 50%;
  transform: translateX(-50%);
  transition: 0.2s;
  z-index: 2;

  :hover {
    transition: 0.2s;
    cursor: pointer;
    opacity: 0.6;
  }

  @media (max-width: 1044px) {
    display: none;
  }

  @media (max-width: 500px) {
    height: 70px;
  }
`;
